import { useTranslation } from "react-i18next";
import React from "react";
import { A } from "../styles/appleClasses";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="w-full px-4 py-4 bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        <span className={`${A.body} text-gray-500`}>
          {t("shell.footer.copyright", { year: new Date().getFullYear() })}
        </span>

        <div className="flex gap-4">
          <a
            href="https://www.nimos.cloud/terms"
            className={`${A.body} text-gray-500 hover:text-gray-700 hover:underline
              focus:outline-none focus:ring-2 focus:ring-appleblueD rounded-md`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("shell.footer.termsOfService")}
          </a>

          <a
            href="https://www.nimos.cloud/privacy"
            className={`${A.body} text-gray-500 hover:text-gray-700 hover:underline
              focus:outline-none focus:ring-2 focus:ring-appleblueD rounded-md`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("shell.footer.privacyPolicy")}
          </a>
        </div>
      </div>
    </footer>
  );
}
